export const chooseAccountDrawerDataLocators = {
    star_icon: 'star-icon',
    choose_account_search_input: 'choose_account_search_input',
    choose_account_cross_icon: 'choose_account_cross_icon',
};
